import { render, staticRenderFns } from "./MainPreload.vue?vue&type=template&id=2cd0ce1a"
import script from "./MainPreload.vue?vue&type=script&lang=js"
export * from "./MainPreload.vue?vue&type=script&lang=js"
import style0 from "./MainPreload.vue?vue&type=style&index=0&id=2cd0ce1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports